export default __webpack_public_path__ + "static/media/ilcasino_receipt.99cb263e.jpg";